import { DefaultActions, Separator, Showing, Total, Search, Wrapper, GridToggles } from '@/components/Grid/components/header/Heading';
import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useMetaFieldStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'

function MetaFieldGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    events: useEvents(),
  })

  return <DefaultGrid filters={null}
    heading={<Wrapper>
      <Search />
      <Separator />
      <GridToggles />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions />
    </Wrapper>}
  />
}

export default function MetaFieldGridLayout() {
  return <GridProvider store={useMetaFieldStore()}>
    <MetaFieldGrid />
  </GridProvider>
}
